/**
 * dialog tempate
 */
export const template = require('./createFolderDialog.template');
/**
 * Controller for the rename item dialog.
 */

export class CreateFolderDialogController{
    public static $inject: string[] = [
        '$mdDialog'        
    ];

    /** The current name of the item */
    public name: string;
    /** The current new item name */
    public regex: RegExp;
    /** The current new item name */
    public newFolderForm: any;

    constructor(private readonly $mdDialog: any){
        this.$mdDialog = $mdDialog;

        // naming convention based on reserved characters for Windows:
        // https://msdn.microsoft.com/en-us/library/windows/desktop/aa365247(v=vs.85).aspx#naming_conventions
        // https://regex101.com/r/xK1gN6/4
        var FOLDER_REGEX = /^[^<>:"/\\|?*.]+([^<>:"/\\|?*](?=.))*[^<>:"/\\|?*.]*$/;
        this.regex = FOLDER_REGEX;
    }

    public trim(){
        if (this.name) {
            this.name = this.name.trim();
        }
    }

    public create(){
        if(!this.newFolderForm.$valid){ return;}

        this.$mdDialog.hide(this.name);
    }
}


// WEBPACK FOOTER //
// ./src/sharebase-app/components/createFolderDialog/createFolderDialog.ts